import type { FastifyInstance } from 'fastify'
import { aiRoutes } from './ai.routes.js'

export default async function aiModule(app: FastifyInstance) {
  await app.register(aiRoutes)
}
